import request from '@/router/axios';
export const add = (row) => {
    return request({
        url: '/api/produce/transport-plan/insert',
        method: 'post',
        data: { ...row, planType: 2 }
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/transport-plan/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-plan/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
/** 本页仅日计划（planType=2），不含合同拆分年/月计划 */
export const getList = (params) => {
    return request({
        url: '/api/produce/transport-plan/select/page',
        method: 'get',
        params: {
            ...params,
            planType: 2,
        }
    })
}
export const getDaytransportplan = (params) => {
    return request({
        url: '/api/produce/transport-plan/selectPlanSummary',
        method: 'post',
        params: {
            ...params,
            planType: 2,
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/produce/transport-plan/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}

export const userSelect = (ids) => {
  return request({
    url: 'api/produce/blade-user/select/userList',
    method: 'get',
    params: {}
  })
}

export const userInsert = (row) => {
  return request({
    url: '/api/produce/blade-user/insert',
    method: 'post',
    data: row
  })
}
